import axios, { AxiosResponse } from "axios";
import {
  DATE_HOUR,
  DATE_MINUTE,
  // IS_ONLINE,
  MESSAGE_TYPE,
} from "../entity/MdmMessage";
import { IS_MFAAUTH, LOCK_STATUS, TENANT_LOCK, ACCESS_AUTH } from "../entity/MdmUser";
import { UserRole } from "../entity/UserRole";
import { Tag } from "../entity/Tag";
import { PullDownItem } from "../components/common/form/FormPullDown";
import { Device } from "../entity/Device";
import { CONTRACT_STATUS } from "../entity/DeviceUser";
import { TenantNameResponse, TenantSearchResponse } from "../components/tenant/api/TenantForm";
import { CompanyNameResponse } from "../components/company/api/CompanyForm";
import { OrganizationNameResponse } from "../components/organization/OrganizationForm";
import { MdmUserNameResponse } from "../components/mdmuser/api/MdmUserForm";
import { IS_MAEBARAI, TENANT_STATUS, TENANT_CONTRACT_DATE_TYPE, IS_TENANT_DELETE, UPPER_OPERATION } from "../entity/Tenant";
import { ApplicationApi } from "../Routing";
import { CONTRACT_TRIAL } from "../entity/Contract";
import { ContractUserNameResponse } from "../components/contractuser/api/ContractUserForm";
export class Utility {

  /**
   * 文字列のNull or Empty処理
   */
  public static NullEmptyStringWrap(str: string) {
    if (str === undefined || str === null || str === "") {
      return "-";
    } else {
      return str;
    }
  }

  public static dateFormat(str: string) {
    let date;
    let dateString = "";
    if (str !== null && "" !== str) {
      date = new Date(str);
      const yyyy: string = date.getFullYear().toString();
      const MM: string = (date.getMonth() + 1).toString().slice(-2);
      const dd: string = date.getDate().toString().slice(-2);
      dateString = yyyy + "/" + MM + "/" + dd;
    }
    return dateString;
  }

  public static dateFormatYmdHi(str: string) {
    let date;
    if ("" !== str) {
      date = new Date(str);
      const yyyy: string = date.getFullYear().toString();
      const MM: string = ("00" + (date.getMonth() + 1)).toString().slice(-2);
      const dd: string = ("00" + date.getDate()).toString().slice(-2);
      const hh: string = ("00" + date.getHours()).toString().slice(-2);
      const ii: string = ("00" + date.getMinutes()).toString().slice(-2);
      date = `${yyyy}/${MM}/${dd} ${hh}:${ii}`;
    }
    return date;
  }

  public static dateFormatdHis(str: string) {
    let date;
    if ("" !== str) {
      const totalSeconds = Number(str);
      if (isNaN(totalSeconds)) return str;

      const dd = Math.floor(totalSeconds / (60 * 60 * 24));
      const hh = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
      const ii = Math.floor((totalSeconds % (60 * 60)) / 60);
      const ss = totalSeconds % 60;

      if (dd > 0) {
        date = `${dd}日${hh}時間`;
      } else if (hh > 0) {
        date = `${hh}時間${ii}分`;
      } else if (ii > 0) {
        date = `${ii}分${ss}秒`;
      } else {
        date = `${ss}秒`;
      }
      return date;
    }
  }

  /**
   * MFA認証選択肢取得
   */
  public static getIsMfaAuthOption() {
    const option: PullDownItem[] = [];
    Object.entries(IS_MFAAUTH).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * ロックステータス選択肢取得
   */
  public static getLockStatusOption() {
    const option: PullDownItem[] = [];
    Object.entries(LOCK_STATUS).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * ユーザーロール選択肢取得API
   */
  public static async getRoleOption(tenantId:Number) {
    const option: PullDownItem[] = [];
    try {
      const result: AxiosResponse = await axios.post(
        ApplicationApi.mdmUserLevel.apiUrl(),
        {"tenantId":tenantId}
      );
      const userRole = result.data.result.userRole as UserRole;
      Object.entries(userRole).forEach(([index, userRole]) => {
        let item: PullDownItem = {
          key: userRole.cd,
          value: userRole.roleName,
        };
        option.push(item);
      });
    } catch (err) {}

    return option;
  }

  /**
   * 時刻選択肢取得
   */
  public static getHourOption() {
    const option: PullDownItem[] = [];
    Object.entries(DATE_HOUR).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    });
    return option;
  }

  public static getMinuteOption() {
    const option: PullDownItem[] = [];
    Object.entries(DATE_MINUTE).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * メッセージ種別選択肢取得
   */
  public static getMessageTypeOption() {
    const option: PullDownItem[] = [];
    Object.entries(MESSAGE_TYPE).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * 日付検索終了日用フォーマット
   */
  public static addDateEndTime(str: string) {
    let date;
    if ("" !== str) {
      let date1 = new Date(str);
      const yyyy: string = date1.getFullYear().toString();
      const MM: string = (date1.getMonth() + 1).toString();
      const dd: string = date1.getDate().toString();
      date = `${yyyy}-${MM}-${dd} 23:59:59.999`;
    }
    return date;
  }

  /**
   * メッセージ送信日時用フォーマット
   */
  public static sendDateFormat(date: string, hour: string, minute: string) {
    let newDate;
    if ("" !== date && "" !== hour && "" !== minute) {
      let date1 = new Date(date);
      const yyyy: string = date1.getFullYear().toString();
      const MM: string = (date1.getMonth() + 1).toString();
      const dd: string = date1.getDate().toString();
      newDate = `${yyyy}-${MM}-${dd} ${hour}:${minute}:00.000`;
    }
    return newDate;
  }

  /**
   * 契約期間登録用フォーマット
   */
  public static registDateFormat(date: string) {
    let newDate = "";
    if ("" !== date) {
      let date1 = new Date(date);
      const yyyy: string = date1.getFullYear().toString();
      const MM: string = (date1.getMonth() + 1).toString();
      const dd: string = date1.getDate().toString();
      newDate = `${yyyy}-${MM}-${dd} 00:00:00.000;`;
    }
    return newDate;
  }

  /**
   * devinfo(FS010M)のdeviceListフォーマット
   */
  public static connectionTimeFormat(str: string) {
    let date;
    if ("" !== str) {
      const utcDate = new Date(str);
      const yyyy: string = utcDate.getUTCFullYear().toString();
      const MM: string = ("00" + (utcDate.getUTCMonth() + 1)).toString().slice(-2);
      const dd: string = ("00" + utcDate.getUTCDate()).toString().slice(-2);
      const hh: string = ("00" + utcDate.getUTCHours()).toString().slice(-2);
      const ii: string = ("00" + utcDate.getUTCMinutes()).toString().slice(-2);
      const ss: string = ("00" + utcDate.getUTCSeconds()).toString().slice(-2);
      date = `${yyyy}/${MM}/${dd} ${hh}:${ii}:${ss}`;
    }
    return date;
  }

  /**
   * YYYY/mm/dd
   * @param str 変換前日付文字列
   * @returns
   */
  public static dateFormatYmdHis(str: string) {
    let date;
    if ("" !== str) {
      date = new Date(str);
      const yyyy: string = date.getFullYear().toString();
      const MM: string = ("00" + (date.getMonth() + 1)).toString().slice(-2);
      const dd: string = ("00" + date.getDate()).toString().slice(-2);
      const hh: string = ("00" + date.getHours()).toString().slice(-2);
      const ii: string = ("00" + date.getMinutes()).toString().slice(-2);
      const ss: string = ("00" + date.getSeconds()).toString().slice(-2);
      date = `${yyyy}/${MM}/${dd} ${hh}:${ii}:${ss}`;
    }
    return date;
  }

  /**
   * テナント企業名の選択肢
   */
  public static getTenantNameOption(tenantList: TenantNameResponse[]) {
    const option: PullDownItem[] = [];
    Object.entries(tenantList).forEach(([index, tenant], i) => {
      let item: PullDownItem = {
        key: tenant.id,
        value: `${tenant.tenantName}【${tenant.companyName}】`,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * 企業名の選択肢 
   */
  public static getCompanyNameOption(companyList: CompanyNameResponse[]) {
    const option: PullDownItem[] = [];
    Object.entries(companyList).forEach(([index, company], i) => {
      let item: PullDownItem = {
        key: company.id,
        value: company.companyName,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * 組織名の選択肢
   */
  public static getOrganizaitonNameOption(organizationList: OrganizationNameResponse[]) {
    const option: PullDownItem[] = [];
    Object.entries(organizationList).forEach(([index, organization], i) => {
      let item: PullDownItem = {
        key: organization.id,
        value: organization.organizationName,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * MDMユーザーの選択肢
   */
  public static getMdmUserNameOption(mdmUserList: MdmUserNameResponse[]) {
    const option: PullDownItem[] = [];
    Object.entries(mdmUserList).forEach(([index, mdmUser], i) => {
      let item: PullDownItem = {
        key: mdmUser.id,
        value: mdmUser.userName + " (" + mdmUser.email + ")",
      };
      option.push(item);
    });
    return option;
  }

  /**
   * MDMユーザーのテナントロックの選択肢
   */
  public static getMdmUserTenantLockOption() {
    const option: PullDownItem[] = [];
    Object.entries(TENANT_LOCK).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * アカウントの種類選択肢
   */
  public static getMdmUserAccessAuth() {
    const option: PullDownItem[] = [];
    Object.entries(ACCESS_AUTH).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * 契約管理システムユーザーの選択肢
   */
  public static getContractUserNameOption(contractUserList: ContractUserNameResponse[]) {
    const option: PullDownItem[] = [];
    Object.entries(contractUserList).forEach(([index, contractUser], i) => {
      let item: PullDownItem = {
        key: contractUser.id,
        value: contractUser.userName,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * テナントステータスの選択肢
   */
  public static getTenantStatusOption() {
    const option: PullDownItem[] = [];
    Object.entries(TENANT_STATUS).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    })
    return option;
  }

  /**
   * テナントの上位操作の選択肢
   */
  public static getUpperOperationOption() {
    const option: PullDownItem[] = [];
    Object.entries(UPPER_OPERATION).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    })
    return option;
  }

  /**
   * テナントの契約日の選択肢
   */
  public static getTenantContractDateOption() {
    const option: PullDownItem[] = [];
    Object.entries(TENANT_CONTRACT_DATE_TYPE).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    })
    return option;
  }

  /**
   * テナントの削除日の選択肢
   */
  public static getDeleteOption() {
    const option: PullDownItem[] = [];
    Object.entries(IS_TENANT_DELETE).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    })
    return option;
  }

  /**
   * 契約条件（前払い）選択肢
   */
  public static getIsMaebaraiOption() {
    const option: PullDownItem[] = [];
    Object.entries(IS_MAEBARAI).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * 契約ステータスの選択肢
   */
  public static getContractStatusOption() {
    const option: PullDownItem[] = [];
    Object.entries(CONTRACT_STATUS).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    });
    return option;
  }

  /**
   * 契約のトライアルの選択肢
   */
  public static getContractTrialOption() {
    const option: PullDownItem[] = [];
    Object.entries(CONTRACT_TRIAL).forEach(([key, value]) => {
      let item: PullDownItem = {
        key,
        value,
      };
      option.push(item);
    });
    return option;
  }
}
